'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RightPane = exports.LeftPane = exports.Footer = undefined;
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _templateObject = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n  min-width: 50%;\n  width: 100%;\n\n  > div[name=\'buttonContainer\'] {\n    padding-right: 16px;\n  }\n'], ['\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n  min-width: 50%;\n  width: 100%;\n\n  > div[name=\'buttonContainer\'] {\n    padding-right: 16px;\n  }\n']),
  _templateObject2 = _taggedTemplateLiteral(['\n  justify-content: flex-end;\n\n  > div[name=\'buttonContainer\'] {\n    padding-left: 16px;\n  }\n'], ['\n  justify-content: flex-end;\n\n  > div[name=\'buttonContainer\'] {\n    padding-left: 16px;\n  }\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Component for displaying the footer in a page or overlay. The footer is divided into left and right sections and buttons can be added in these sections.
 */
var Footer = function (_React$Component) {
  _inherits(Footer, _React$Component);
  function Footer(props) {
    _classCallCheck(this, Footer);
    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));
  }
  _createClass(Footer, [{
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        /**
         * Wrap each button into a div with a bottom left to space each
         * button from each other.
         */
        var renderChildren = function () {
          function renderChildren() {
            return _react2['default'].Children.map(_this2.props.children, function (child, index) {
              return _react2['default'].cloneElement(child, {
                key: 'pane_' + index
              });
            });
          }
          return renderChildren;
        }();
        return _react2['default'].createElement('div', {
          name: 'footer',
          className: this.props.className
        }, renderChildren());
      }
      return render;
    }()
  }]);
  return Footer;
}(_react2['default'].Component);
var LeftPaneBase = function (_React$Component2) {
  _inherits(LeftPaneBase, _React$Component2);
  function LeftPaneBase(props) {
    _classCallCheck(this, LeftPaneBase);
    return _possibleConstructorReturn(this, (LeftPaneBase.__proto__ || Object.getPrototypeOf(LeftPaneBase)).call(this, props));
  }
  _createClass(LeftPaneBase, [{
    key: 'render',
    value: function () {
      function render() {
        var _this4 = this;
        var renderButtons = function () {
          function renderButtons() {
            return _react2['default'].Children.map(_this4.props.children, function (child) {
              if (child) {
                return _react2['default'].createElement('div', {
                  name: 'buttonContainer'
                }, child);
              } else {
                return null;
              }
            });
          }
          return renderButtons;
        }();
        return _react2['default'].createElement('div', {
          className: this.props.className
        }, renderButtons());
      }
      return render;
    }()
  }]);
  return LeftPaneBase;
}(_react2['default'].Component);
var LeftPaneStyled = (0, _styledComponents2['default'])(LeftPaneBase)(_templateObject);

/**
 * The container component for the left side buttons.
 */

var LeftPane = function (_React$Component3) {
  _inherits(LeftPane, _React$Component3);
  function LeftPane() {
    _classCallCheck(this, LeftPane);
    return _possibleConstructorReturn(this, (LeftPane.__proto__ || Object.getPrototypeOf(LeftPane)).apply(this, arguments));
  }
  _createClass(LeftPane, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(LeftPaneStyled, this.props);
      }
      return render;
    }()
  }]);
  return LeftPane;
}(_react2['default'].Component);
var RightPaneStyled = (0, _styledComponents2['default'])(LeftPaneStyled)(_templateObject2);

/**
 * The container component for the right side buttons.
 */

var RightPane = function (_React$Component4) {
  _inherits(RightPane, _React$Component4);
  function RightPane() {
    _classCallCheck(this, RightPane);
    return _possibleConstructorReturn(this, (RightPane.__proto__ || Object.getPrototypeOf(RightPane)).apply(this, arguments));
  }
  _createClass(RightPane, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(RightPaneStyled, this.props);
      }
      return render;
    }()
  }]);
  return RightPane;
}(_react2['default'].Component);
exports.Footer = Footer;
exports.LeftPane = LeftPane;
exports.RightPane = RightPane;